import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";

const UpdateCreditsModal = ({ isOpen, product, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const currentCredits = product?.latest_renewal?.credits_remaining || 0;
  const [creditsRemaining, setCreditsRemaining] = useState(currentCredits);
  const [notes, setNotes] = useState("");

  if (!isOpen || !product) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (creditsRemaining === "" || Number(creditsRemaining) < 0) {
      showToast.error("Please enter a valid remaining credits balance");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.patch(
        `${API_URL}settings/product-subscriptions/${product.id}/credits`,
        {
          credits_remaining: Number(creditsRemaining),
          notes: notes.trim() || undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.data) {
        showToast.success("Credits balance updated successfully!");
        onSuccess(response.data.data);
        onClose();
      }
    } catch (err) {
      console.error("Error updating credits balance:", err);
      const msg = err.response?.data?.message || "Failed to update credits.";
      showToast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">Update Credits</h5>
            <button
              type="button"
              className="btn btn-default btn-xs"
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <p className="text-muted small mb-2">
                Product: <strong>{product.product_name}</strong>
              </p>

              <div className="mb-2">
                <label className="form-label fw-bold small">
                  Credits Remaining <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  step="any"
                  className="form-control form-control-sm"
                  value={creditsRemaining}
                  onChange={(e) => setCreditsRemaining(e.target.value)}
                  required
                />
                <small className="text-muted">
                  Low balance alert threshold: {product.latest_renewal?.low_balance_alert_at || 0}
                </small>
              </div>

              <div className="mb-2">
                <label className="form-label fw-bold small">Remarks</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="e.g. Monthly consumption update"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={onClose}
                disabled={loading}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-sm"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateCreditsModal;
